import * as cheerio from 'cheerio';
import { getNetlifyImageUrl, generateNetlifySrcSet } from './ImageNetlify';

const ContentImageNetlify = (
  html,
  {
    widths = [640, 1280, 1700],
    includeRetina = true,
    sizes = "(max-width: 1700px) 100vw, 1700px",
    shouldProcess = (src) => src.includes("wp-content"),
  } = {}
) => {
  if (!html) return html;

  const $ = cheerio.load(html);
  const isDev = process.env.NODE_ENV === "development";

  $("img").each((index, img) => {
    const src = $(img).attr("src");
    const alt = $(img).attr("alt") || "";
    const width = $(img).attr("width");
    const height = $(img).attr("height");
    const classAttr = $(img).attr("class") || "";

    if (!src || !shouldProcess(src)) return;

    $(img).attr("decoding", "async");

    if (isDev) return;

    const baseWidths = includeRetina ? [...widths, ...widths.map(w => w * 2)] : widths;
    const defaultWidth = Math.max(...widths);
    const defaultSrc = getNetlifyImageUrl(src, defaultWidth);
    const srcset = generateNetlifySrcSet(src, baseWidths);

    // Set loading "lazy" except for the first image
    const loading = (index === 0 ? "" : "lazy");

    const $newImg = $("<img />")
    .attr("src", defaultSrc)
    .attr("srcset", srcset)
    .attr("sizes", sizes)
    .attr("alt", alt)
    .attr("class", classAttr)
    .attr("decoding", "async")

    if (loading) $newImg.attr("loading", loading);
    if (width) $newImg.attr("width", width);
    if (height) $newImg.attr("height", height);

    $(img).replaceWith($newImg);
  });

  return $.html();
};

export default ContentImageNetlify;
